const orderSelect = document.getElementById('archive-property__order-select');
const filterLabels = document.querySelectorAll(
  '.archive-property__form__filters__section > label'
);
const form = document.querySelector('.archive-property__form');
const containerMap = document.getElementById('archive-property__map-result');

const setSelectSize = () => {
  const selectedOption =
    orderSelect.options[orderSelect.selectedIndex].textContent;

  const span = document.createElement('span');
  span.style.position = 'absolute';
  span.style.left = '-9999px';
  span.style.top = '-9999px';
  span.style.visibility = 'hidden';
  span.style.fontSize = '1.4rem';
  span.style.textTransform = 'uppercase';
  span.style.letterSpacing = '2px';
  span.textContent = selectedOption;

  document.body.appendChild(span);
  const width = span.offsetWidth;
  document.body.removeChild(span);
  orderSelect.style.width = `${width}px`;
};

filterLabels.forEach((label) => {
  label.addEventListener('click', () => {
    if (!form.hasAttribute('data-deployed')) {
      form.setAttribute('data-deployed', true);
    } else {
      form.removeAttribute('data-deployed');
    }
  });
});

orderSelect.addEventListener('change', setSelectSize);
setSelectSize();

window.addEventListener('load', () => {
  const selectedOption = orderSelect.options[orderSelect.selectedIndex].value;
  orderSelect.setAttribute('data-select', selectedOption);
});

if (containerMap) {
  mapboxgl.accessToken =
    'pk.eyJ1IjoidGFuLWtpIiwiYSI6ImNsZDRidjBtejBxeTMzeG9nZ3JtcWs2dGsifQ.uKrP8MsXPQHZbhgBHfd0rw';

  const mapResult = new mapboxgl.Map({
    container: 'archive-property__map-result',
    style: 'mapbox://styles/tan-ki/clgm9u36o00c901mjazd99mj1',
    attributionControl: false,
  });

  mapResult.scrollZoom.disable();
  mapResult.addControl(new mapboxgl.NavigationControl());
}
